
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { AppComponent } from './app.component';
import { FlexLayoutModule } from "@angular/flex-layout";
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { AgularMaterialModule } from './material.module';

// Services
import { PaginationService, BaseLoaderService } from './services';

// Lib

// Config
import {BaseLoaderComponent} from "./lib/base-loader/base-loader";
import {FilterPipe} from "./lib/search/filter.pipe";
import {AudioRecordingService} from "./lib/AudioRecordingService";
import {NgxEmojiPickerModule} from "ngx-emoji-picker";

// Directives

// Page Components

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        // HttpModule,
        HttpClientModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        AgularMaterialModule,
        HttpModule,
        NgxEmojiPickerModule.forRoot(),
        FlexLayoutModule,
        MalihuScrollbarModule.forRoot(),
        // NgxEditorModule,
        // NgProgressModule,
    ],
    providers: [
        PaginationService,
        BaseLoaderService,
        GoogleMapsAPIWrapper,
        AudioRecordingService,
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        // { provide: OWL_DATE_TIME_FORMATS, useValue: 'fr' },
        // {provide: HTTP_INTERCEPTORS, useClass: NgProgressInterceptor, multi: true },
    ],
    declarations: [
        AppComponent,
        BaseLoaderComponent,
        FilterPipe
    ],
    entryComponents: [
        // [AppComponent]
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }





// WEBPACK FOOTER //
// ./src/app/app.module.ts